import BreathingTranslationsResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BreathingService/BreathingTranslationsResponse";

export default class BreathingTranslateViewModel {
	id?: number = 0;
    langCode?: string = '';
	name?: string = '';
	categoryName?: string = '';
	description?: string = '';
    constructor(obj?: Partial<BreathingTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): BreathingTranslationsResponse {
        const res = new BreathingTranslationsResponse({
            Description: this.description,
            LangCode: this.langCode,
            Name: this.name,
            Id: this.id,
            CategoryName: this.categoryName
        });
        return res;
    }
}
